module.exports = __webpack_public_path__ + "img/mood2.bf08ffb4.png";